@let range = dateRange();

<div class="dialog">

  <section class="dialog__header">Select date range</section>

  <section class="dialog__content">
    <div class="calendars"
         attachDeviceWidth>
      <div class="calendar">
        <mat-calendar [selected]="range"
                      [startAt]="calendarFromStartAt()"
                      [comparisonStart]="range.start"
                      [comparisonEnd]="range.end"
                      (selectedChange)="setDate($event)"></mat-calendar>
      </div>
      <div class="calendar">
        <mat-calendar [selected]="range"
                      [startAt]="calendarToStartAt()"
                      [comparisonStart]="range.start"
                      [comparisonEnd]="range.end"
                      (selectedChange)="setDate($event)"></mat-calendar>
      </div>
    </div>
  </section>

  <section class="dialog__footer">

    <kt-generic-button appearance="flat"
                       color="primary"
                       [disabled]="!range.start || !range.end"
                       (click)="submit(range)">Apply</kt-generic-button>

    <kt-generic-button appearance="stroked"
                       (click)="cancel()">Cancel</kt-generic-button>

  </section>
</div>